import { createWagmiConfig } from "@latticexyz/entrykit/internal";
import { chain, supportedChains } from "./chain";
import { transports } from "./transports";
import { anvil } from "./anvil";
import { rhodolite } from "@latticexyz/common/chains";

export const wagmiConfig = createWagmiConfig({
  chainId: chain.id,
  walletConnectProjectId: "14ce88fdbc0f9c294e26ec9b4d848e44",
  appName: "Doom on Quarry",
  chains: supportedChains,
  transports,
  pollingInterval: {
    [anvil.id]: 2000,
    [rhodolite.id]: 2000,
  },
  credentialOptions: {
    rp: location.origin.endsWith(".onquarry.com")
      ? {
          id: "onquarry.com",
          name: "Quarry",
        }
      : undefined,
  },
});
